var map = {
	"./logo__1.svg": 676,
	"./logo__11.svg": 677,
	"./logo__12.svg": 678,
	"./logo__13.svg": 679,
	"./logo__14.svg": 680,
	"./logo__15.svg": 681,
	"./logo__2.svg": 682,
	"./logo__24.svg": 683,
	"./logo__3.svg": 684,
	"./logo__4.svg": 685,
	"./logo__44.svg": 686,
	"./logo__5.svg": 687,
	"./logo__6.svg": 688,
	"./logo__62.svg": 689,
	"./logo__7.svg": 690,
	"./logo__8.svg": 691,
	"./logo__9.svg": 692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 930;